import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { SearchBox } from "../components/SearchBox";
import type { SearchHit } from "@shared/types";

export function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") ?? "";
  const [hits, setHits] = useState<SearchHit[]>([]);
  useEffect(() => {
    if (!q) return;
    api<{ results: SearchHit[] }>(`/api/search?q=${encodeURIComponent(q)}`).then((r) => setHits(r.results)).catch(() => setHits([]));
  }, [q]);
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Search</p>
        <h1>Models, studies, assumptions, people, decisions.</h1>
        <SearchBox initial={q} autoFocus />
        <div className="results">
          {hits.map((h) => (
            <Link className="result" key={h.objectId} to={h.href}>
              <span className="kicker">{h.objectType}</span>
              <h3>{h.title}</h3>
              <p className="muted small">{h.snippet}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
